var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    viewBox: "0 0 43 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2770FF",
    d: "M21.578 15.38l-2.828 1.648-12.897-7.49 5.258-3.097 12.005 6.991 1.984 1.149h2.629l7.192-4.195V8.69L19.991 0h-2.63l-3.72 2.147 2.43 1.398 2.63-1.548 12.897 7.49-5.06 2.996-12.897-7.49-1.091-.649H9.92L2.48 8.69v1.697l16.32 9.488 5.209-3.046-2.431-1.448zM17.808 21.572l-16.32-9.438c-.645.35-.794.45-1.438.849L0 31.359c.149.3.298.549.496.849l1.984 1.148v-7.74l12.798 7.44v7.74l2.48 1.448.05-20.672zM2.53 22.47v-6.89l12.798 7.44v6.89L2.53 22.47zM35.963 23.22l1.439-1.748v-8.24c-.745-.449-.943-.549-1.737-.998l-15.922 9.338-.05 20.622 16.32-9.537c.446-.799.843-1.448 1.29-2.297v-6.092l-1.34-1.049zm-1.091 7.19l-12.65 7.44v-5.443l12.65-7.34v5.343zm0-8.14l-12.65 7.341V23.07l12.65-7.39v6.59z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.cf056709.svg";
export { ForwardRef as ReactComponent };